// extracted by mini-css-extract-plugin
export default {"html__container":"styles_html__container__hnd7x"};